import type { IUserState, IUserStore } from './interfaces';
import type { Bruker } from './types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export const userInitialState: IUserState = {
    user: undefined,
    userIsLoading: false,
    devRoleOverride: null,
};

export const userSlice = createSlice({
    name: 'user',
    initialState: userInitialState,
    reducers: {
        userFetchSuccess(state, action: PayloadAction<Bruker | undefined>) {
            state.user = action.payload;
            state.userIsLoading = false;
        },
        setDevRoleOverride(
            state,
            action: PayloadAction<Partial<Bruker> | null>,
        ) {
            state.devRoleOverride = action.payload;
        },
        clearDevRoleOverride(state) {
            state.devRoleOverride = null;
        },
    },
});

export const { userFetchSuccess, setDevRoleOverride, clearDevRoleOverride } =
    userSlice.actions;

export const userActions = {
    ...userSlice.actions,
};

export const userSelectors = ({ user }: IUserStore): IUserState => user;

export const userReducer = userSlice.reducer;
